import { useEffect, useState } from 'react';
import { getSessionOnce } from '../providers/authProvider';
import { Session } from '@ory/client';

export type SessionData = Session & {
  identity: {
    metadata_public: {
      tenantId: string;
      userId: string;
    };
  };
};

export const useSessionData = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [session, setSession] = useState<SessionData | null>(null);

  useEffect(() => {
    getSessionOnce()
      .then((session: SessionData) => {
        setIsLoading(false);
        setSession(session);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  return { isLoading, session };
};
